/* ==========================================================================
   Subscription buy box - option 3, "inverted colour" (Shoplift test)
   --------------------------------------------------------------------------
   Replaces Skio's two-radio plan picker with a one-time row plus a plan card
   that has an on/off switch.

   The discount is not faked. Skio's <skio-plan-picker> stays in the DOM
   (visually hidden) as the source of truth: we click its real radios inside
   the shadow root and it writes selling_plan into the product form, so the
   subscription price survives to checkout and tracks Skio's config.

   Copy and the device image come from sections/sk-subs-pdp.liquid via the
   #sk-subs-pdp-config JSON block. Nothing store-specific lives in this file.
   With showWasPrice on, the full price (compare-at, else one-time) is shown
   slashed out next to the subscription price, in the card and on the button.
   ========================================================================== */
(function () {
  'use strict';

  // The section could be added to a template twice; only ever run once.
  if (window.__skSubsPdp) return;
  window.__skSubsPdp = true;

  var CONFIG = readConfig();

  var ICONS = {
    switch:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 11a8 8 0 0 1 13.6-5.7L20 8"/><path d="M20 4v4.5h-4.5"/>' +
      '<path d="M21 13a8 8 0 0 1-13.6 5.7L4 16"/><path d="M4 20v-4.5h4.5"/></svg>',
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M1.5 6.5h11v9h-11z"/><path d="M12.5 9.5h4.7l3.3 3.2v2.8h-8z"/>' +
      '<circle cx="6" cy="17.5" r="1.9"/><circle cx="16.5" cy="17.5" r="1.9"/></svg>',
    pause:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9"/><path d="M10 9v6M14 9v6"/></svg>',
    gift:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 9.5h18v3.5H3z"/><path d="M4.75 13h14.5v7h-14.5z"/><path d="M12 9.5V20"/>' +
      '<path d="M12 9.5S10.6 4.2 8.1 4.2a2.15 2.15 0 0 0 0 5.3z"/>' +
      '<path d="M12 9.5s1.4-5.3 3.9-5.3a2.15 2.15 0 0 1 0 5.3z"/></svg>'
  };
  var ICON_ORDER = ['switch', 'truck', 'pause', 'gift'];

  var state = { on: CONFIG.defaultOn, planId: null };
  var cards = [];
  var syncing = false;
  var originalLabel = '';

  /* ----------------------------------------------------------------- config */

  function readConfig() {
    var defaults = {
      defaultOn: true,
      defaultFrequency: '',
      title: 'Save {discount} With Our Flexible Plan',
      titleExtra: '',
      oneTimeLabel: 'One-time purchase',
      benefits: [],
      freeLabel: 'FREE',
      worthLabel: '',
      deviceImage: '',
      deviceAlt: 'Rechargeable device',
      showWasPrice: false
    };
    var el = document.getElementById('sk-subs-pdp-config');
    if (!el) return defaults;
    try {
      var parsed = JSON.parse(el.textContent);
      for (var k in parsed) {
        if (Object.prototype.hasOwnProperty.call(parsed, k) && parsed[k] !== null) defaults[k] = parsed[k];
      }
    } catch (e) {
      if (window.console) console.warn('[sk-subs-pdp] config unreadable, using defaults', e);
    }
    defaults.defaultOn = defaults.defaultOn !== false;
    defaults.showWasPrice = defaults.showWasPrice === true;
    return defaults;
  }

  /* ---------------------------------------------------------------- helpers */

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function pickers() {
    return Array.prototype.slice
      .call(document.querySelectorAll('skio-plan-picker'))
      .filter(function (p) {
        return p.shadowRoot && p.shadowRoot.querySelector('input[skio-selling-plan-group]');
      });
  }

  function subRadio(p) {
    return p.shadowRoot.querySelector('input[skio-selling-plan-group]');
  }

  function oneTimeRadio(p) {
    return p.shadowRoot.querySelector('input[skio-one-time]');
  }

  function freqSelect(p) {
    return p.shadowRoot.querySelector('select.skio-frequency');
  }

  function skioText(selector) {
    var p = pickers()[0];
    var el = p && p.shadowRoot.querySelector(selector);
    var txt = el && el.textContent ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return txt || '';
  }

  // Full price for the slash: the variant's compare-at price when it has one,
  // otherwise its one-time price. Read from Skio's own variant data and money
  // formatter, so it matches Skio's other prices exactly.
  function fullPriceText() {
    var p = pickers()[0];
    var v = p && p.selectedVariant;
    if (!v) return '';
    var cents = Math.max(Number(v.compare_at_price) || 0, Number(v.price) || 0);
    if (!cents) return '';
    try {
      var fmt = p.moneyFormatter || new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
      return fmt.format(cents / 100);
    } catch (e) {
      return '';
    }
  }

  // True when the variant already sells below its compare-at price (the kits),
  // so the plan's discount comes on top of a saving the page already shows.
  function hasSlashedPrice() {
    var p = pickers()[0];
    var v = p && p.selectedVariant;
    return !!v && (Number(v.compare_at_price) || 0) > (Number(v.price) || 0);
  }

  function amount(text) {
    var n = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  // The slashed price, or '' when it's off or wouldn't be higher than the sub price.
  function wasText(sub) {
    if (!CONFIG.showWasPrice || !sub) return '';
    var full = fullPriceText();
    return full && amount(full) > amount(sub) ? full : '';
  }

  function freqOptions(p) {
    var sel = freqSelect(p);
    if (!sel) return [];
    return Array.prototype.slice.call(sel.options).map(function (o) {
      return { value: o.value, label: (o.text || '').replace(/\s+/g, ' ').trim() };
    });
  }

  // Match the configured default (e.g. "4 weeks") against Skio's option labels.
  // Plan IDs differ per product and per store, so the label is the only thing
  // one setting can target. The number must stand alone, so "4 weeks" never
  // matches "14 weeks". No match -> null, and Skio's own default is kept.
  function planIdForFrequency(p, wanted) {
    var needle = String(wanted || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!needle) return null;
    var pattern = new RegExp(
      '(^|[^0-9a-z])' + needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^0-9a-z])'
    );
    var hit = freqOptions(p).filter(function (o) { return pattern.test(o.label.toLowerCase()); })[0];
    return hit ? hit.value : null;
  }

  function atcButton() {
    return document.querySelector('.quantity-submit-row__submit button');
  }

  // The plan has to be read from the Add to Cart button's own form: the page
  // also carries add-on quick-add forms, so "the first product form" isn't safe.
  function productForm() {
    var b = atcButton();
    return (b && (b.form || b.closest('form'))) || document.querySelector('form.product-purchase-form');
  }

  function formSellingPlan() {
    var f = productForm();
    var input = f && f.querySelector('input[name="selling_plan"]');
    return input ? input.value : '';
  }

  // Does the form currently carry what the card is showing? With no frequency
  // select there is no planId, so any plan counts as "on".
  function planMatchesState() {
    var actual = formSellingPlan();
    if (!state.on) return actual === '';
    return state.planId ? actual === String(state.planId) : actual !== '';
  }

  /* ------------------------------------------------- Add to Cart button sync */

  // Every write to the button happens in reaction to a MutationObserver on that
  // same button, so a write that never settles retriggers itself forever. That
  // is exactly how the starter kit page locked up: the template label used
  // single quotes, innerHTML re-serialised them as double quotes, and the
  // comparison never matched. Two defences here:
  //   1. both sides of every comparison go through the HTML parser, and
  //   2. a breaker stops all writes after a burst, until the shopper next
  //      interacts - so a runaway loop dies, but ordinary toggling never
  //      runs out of writes the way a fixed lifetime cap would.
  var probe = document.createElement('div');
  function normalise(html) {
    probe.innerHTML = html;
    return probe.innerHTML.replace(/\s+/g, ' ').trim();
  }

  // The theme legitimately rewrites the button several times while the page
  // loads, and each of those needs one correction, so the limit is generous: a
  // real loop spins hundreds of times a second and trips it almost instantly.
  var BREAKER_WRITES = 12;
  var BREAKER_WINDOW_MS = 3000;
  var breaker = { stamps: [], tripped: false };
  function allowWrite() {
    if (breaker.tripped) return false;
    var now = Date.now();
    breaker.stamps = breaker.stamps.filter(function (t) { return now - t < BREAKER_WINDOW_MS; });
    if (breaker.stamps.length >= BREAKER_WRITES) {
      breaker.tripped = true;
      if (window.console) console.warn('[sk-subs-pdp] Add to Cart write limit reached; standing down until the next interaction');
      return false;
    }
    breaker.stamps.push(now);
    return true;
  }
  function rearmBreaker() {
    breaker.stamps = [];
    breaker.tripped = false;
  }

  // Template label (e.g. the responsive "Add to Cart" / "Add" spans) captured
  // before Skio flattens it to a hardcoded "Add to Cart".
  function captureLabel() {
    if (originalLabel) return;
    var b = atcButton();
    if (!b) return;
    var attr = b.getAttribute('data-add-to-cart-text') || '';
    if (attr.replace(/\s+/g, '')) {
      originalLabel = attr;
      return;
    }
    var i = b.innerHTML.indexOf('|');
    if (i > -1) originalLabel = b.innerHTML.slice(0, i);
  }

  // Desired button: template label, then
  //   on  -> the subscription price ("| £42.50"), with the full price slashed
  //          out in front when showWasPrice is on ("| <del>$92.00</del> $61.20")
  //   off -> whatever Skio wrote for one-time, compare price included.
  function syncButton() {
    var b = atcButton();
    if (!b) return;
    var html = b.innerHTML;
    var i = html.indexOf('|');
    if (i === -1) return; // sold out or an unexpected format - leave it alone

    var label = originalLabel || html.slice(0, i);
    var price = html.slice(i + 1);

    if (state.on) {
      // Only claim the subscription price once the form really carries the
      // plan. Until Skio has applied it, Skio's or the theme's own one-time
      // output stays - otherwise a shopper could tap "£42.50" and pay £50.
      // It also means the sub-only format can only exist while Skio's
      // subscription radio is checked, so switching off is always a real Skio
      // change that rewrites the button honestly.
      if (!planMatchesState()) return;
      var sub = skioText('[skio-subscription-price]');
      if (!sub) return; // Skio not ready; never guess a price
      var was = wasText(sub);
      price = was
        ? ' <del>' + escapeHtml(was) + '</del> ' + escapeHtml(sub)
        : ' ' + escapeHtml(sub);
    }

    var desired = label.replace(/\s+$/, '') + ' |' + price;
    if (normalise(desired) === normalise(html)) return;
    if (!allowWrite()) return;
    b.innerHTML = desired;
  }

  function watchButton() {
    var row = document.querySelector('.quantity-submit-row__submit');
    if (!row || !window.MutationObserver) return;
    var timer = null;
    new MutationObserver(function () {
      // coalesce a burst of Skio/theme writes into one check once they stop
      clearTimeout(timer);
      timer = setTimeout(syncButton, 40);
    }).observe(row, { childList: true, subtree: true, characterData: true });
  }

  /* -------------------------------------------------------- drive real Skio */

  // Clicking a shadow radio makes Skio re-render, so always re-query.
  // bounce: click the other radio first, forcing a real change - Skio ignores a
  // click on the radio that is already checked.
  function pushToSkio(bounce) {
    syncing = true;
    pickers().forEach(function (p) {
      var other = state.on ? oneTimeRadio(p) : subRadio(p);
      if (bounce && other) other.click();

      var wanted = state.on ? subRadio(p) : oneTimeRadio(p);
      if (wanted && (bounce || !wanted.checked)) wanted.click();

      if (state.on && state.planId) {
        var sel = freqSelect(p);
        if (sel && sel.value !== state.planId) {
          sel.value = state.planId;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    setTimeout(function () { syncing = false; }, 350);
  }

  // Confirm selling_plan really landed on the form (Skio can drop a click that
  // arrives mid re-render), then bring the button in line.
  function pushAndVerify(attempt) {
    attempt = attempt || 0;
    pushToSkio(attempt > 0);
    setTimeout(function () {
      var planOk = planMatchesState();
      renderPrices();
      syncButton();
      if (!planOk && attempt < 5) pushAndVerify(attempt + 1);
    }, 600);
  }

  // Last line of defence. If Add to Cart is tapped while the form disagrees
  // with the card (mid-transition, or before the opening push has landed),
  // apply the card's state to Skio before the theme reads the form. Capture
  // phase, so this runs ahead of the theme's and the cart app's handlers.
  function guardAddToCart() {
    var b = atcButton();
    var f = productForm();
    function align() {
      if (!planMatchesState()) pushToSkio(false);
    }
    if (b) b.addEventListener('click', align, true);
    if (f) f.addEventListener('submit', align, true);
  }

  // Skio mirrors its live price onto [skio_price] as an attribute; a change we
  // didn't cause means something reset the picker, so put it back.
  function watchSkio() {
    var mirror = document.querySelector('[skio_price]');
    if (!mirror || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (syncing) return;
      renderPrices();
      if (!!formSellingPlan() !== state.on) pushAndVerify();
    }).observe(mirror, { attributes: true, attributeFilter: ['skio-price'] });
  }

  function whenSettled(fn) {
    if (document.readyState === 'complete') {
      setTimeout(fn, 600);
    } else {
      window.addEventListener('load', function () { setTimeout(fn, 600); }, { once: true });
    }
  }

  /* ------------------------------------------------------------------- card */

  function setOn(on) {
    rearmBreaker(); // a shopper action always gets fresh writes
    state.on = on;
    render();
    pushAndVerify();
  }

  // Skio's discount is taken off the one-time price. On a product that already
  // has a slashed price, a plain "Save 15%" reads as 15% off the slashed price,
  // so those use the "extra" title instead.
  function titleHtml() {
    var discount = skioText('[skio-discount]') || '15%';
    var tpl = (CONFIG.titleExtra && hasSlashedPrice()) ? CONFIG.titleExtra : CONFIG.title;
    return escapeHtml(tpl || '').replace('{discount}', escapeHtml(discount));
  }

  function buildCard(wrapper, picker) {
    var root = document.createElement('div');
    root.className = 'sk-sp';

    var benefits = (CONFIG.benefits || [])
      .map(function (text, i) { return { text: text, icon: ICON_ORDER[i] || 'switch' }; })
      .filter(function (b) { return b.text && String(b.text).trim(); });

    var options = freqOptions(picker)
      .map(function (o) {
        return '<option value="' + escapeHtml(o.value) + '">' + escapeHtml(o.label) + '</option>';
      })
      .join('');

    root.innerHTML =
      '<button type="button" class="sk-sp__onetime" role="radio" aria-checked="false">' +
        '<span class="sk-sp__radio" aria-hidden="true"></span>' +
        '<span class="sk-sp__onetime-label">' + escapeHtml(CONFIG.oneTimeLabel) + '</span>' +
        '<span class="sk-sp__onetime-price" data-sk-price="onetime"></span>' +
      '</button>' +
      '<div class="sk-sp__card" role="group">' +
        '<div class="sk-sp__head">' +
          '<p class="sk-sp__title"></p>' +
          '<button type="button" class="sk-sp__switch" role="switch" aria-checked="false"></button>' +
        '</div>' +
        '<div class="sk-sp__body">' +
          '<div class="sk-sp__left">' +
            (benefits.length
              ? '<ul class="sk-sp__benefits">' +
                  benefits.map(function (b) {
                    return '<li>' + ICONS[b.icon] + '<span>' + escapeHtml(b.text) + '</span></li>';
                  }).join('') +
                '</ul>'
              : '') +
            (options
              ? '<div class="sk-sp__freq"><select aria-label="Delivery frequency">' + options + '</select></div>'
              : '') +
          '</div>' +
          '<div class="sk-sp__right">' +
            (CONFIG.deviceImage
              ? '<img class="sk-sp__device" src="' + escapeHtml(CONFIG.deviceImage) + '" alt="' +
                escapeHtml(CONFIG.deviceAlt) + '" decoding="async" width="120" height="184">'
              : '') +
            (CONFIG.freeLabel ? '<span class="sk-sp__free">' + escapeHtml(CONFIG.freeLabel) + '</span>' : '') +
            (CONFIG.worthLabel ? '<span class="sk-sp__worth">' + escapeHtml(CONFIG.worthLabel) + '</span>' : '') +
            '<span class="sk-sp__price" data-sk-price="subscription"></span>' +
            (CONFIG.showWasPrice ? '<s class="sk-sp__was" data-sk-price="was" hidden></s>' : '') +
          '</div>' +
        '</div>' +
      '</div>';

    root.querySelector('.sk-sp__onetime').addEventListener('click', function () {
      if (state.on) setOn(false);
    });

    root.querySelector('.sk-sp__switch').addEventListener('click', function (e) {
      e.stopPropagation();
      setOn(!state.on);
    });

    // The greyed card is an invitation: clicking anywhere on it switches the
    // plan on. Once on, only the switch turns it off.
    root.querySelector('.sk-sp__card').addEventListener('click', function (e) {
      if (state.on || e.target.closest('select')) return;
      setOn(true);
    });

    var select = root.querySelector('.sk-sp__freq select');
    if (select) {
      select.addEventListener('change', function () {
        state.planId = select.value;
        if (!state.on) {
          setOn(true);
        } else {
          rearmBreaker();
          render();
          pushAndVerify();
        }
      });
    }

    wrapper.appendChild(root);
    wrapper.classList.add('sk-sp-ready');
    cards.push(root);
  }

  // Also run from renderPrices, so a variant change re-picks the title.
  function renderTitle() {
    var title = titleHtml();
    cards.forEach(function (card) {
      var t = card.querySelector('.sk-sp__title');
      if (t && t.innerHTML !== title) t.innerHTML = title;
      var text = (t && t.textContent) || '';
      var sw = card.querySelector('.sk-sp__switch');
      var group = card.querySelector('.sk-sp__card');
      if (sw.getAttribute('aria-label') !== (text || 'Subscribe and save')) sw.setAttribute('aria-label', text || 'Subscribe and save');
      if (group.getAttribute('aria-label') !== text) group.setAttribute('aria-label', text);
    });
  }

  function renderPrices() {
    renderTitle();
    var oneTime = skioText('[skio-onetime-price]');
    var sub = skioText('[skio-subscription-price]');
    var was = wasText(sub);
    cards.forEach(function (card) {
      var a = card.querySelector('[data-sk-price="onetime"]');
      var b = card.querySelector('[data-sk-price="subscription"]');
      var c = card.querySelector('[data-sk-price="was"]');
      if (a && a.textContent !== oneTime) a.textContent = oneTime;
      if (b && b.textContent !== sub) b.textContent = sub;
      if (c) {
        if (c.textContent !== was) c.textContent = was;
        c.hidden = !was;
        if (was) c.setAttribute('aria-label', 'Full price ' + was);
      }
    });
  }

  function render() {
    cards.forEach(function (card) {
      card.classList.toggle('is-on', state.on);

      card.querySelector('.sk-sp__switch').setAttribute('aria-checked', state.on ? 'true' : 'false');
      card.querySelector('.sk-sp__onetime').setAttribute('aria-checked', state.on ? 'false' : 'true');

      var sel = card.querySelector('.sk-sp__freq select');
      if (sel && state.planId && sel.value !== state.planId) sel.value = state.planId;
    });
    renderPrices();
  }

  /* -------------------------------------------------------------- bootstrap */

  function init() {
    captureLabel();
    var ps = pickers();
    if (!ps.length) return false;

    // Opening frequency: the configured default if this product offers it,
    // otherwise whatever Skio has selected.
    if (!state.planId) {
      var sel = freqSelect(ps[0]);
      var first = freqOptions(ps[0])[0];
      state.planId =
        planIdForFrequency(ps[0], CONFIG.defaultFrequency) ||
        (sel && sel.value) || (first && first.value) || null;
    }

    ps.forEach(function (p) {
      var wrapper = p.closest('.skio-wrapper') || p.parentElement;
      if (!wrapper || wrapper.classList.contains('sk-sp-ready')) return;
      // Never inside the Add to Cart row: on mobile that row is the fixed
      // sticky bar, and a card there covers the page.
      if (wrapper.closest('.quantity-submit-row')) return;
      buildCard(wrapper, p);
    });

    if (!cards.length) return false;

    ps.forEach(function (p) { p.setAttribute('aria-hidden', 'true'); });
    document.documentElement.classList.add('sk-sp-on');
    render();
    watchButton();
    guardAddToCart();

    // Apply the opening state immediately. Waiting for window load left
    // seconds on a heavy page where the card said "on" but Skio was still on
    // one-time.
    pushAndVerify();
    watchSkio();

    whenSettled(function () {
      // The theme rewrites the button during load and may have reset things;
      // re-assert once it's quiet, with a fresh set of writes.
      rearmBreaker();
      pushAndVerify();
    });
    return true;
  }

  // Skio hydrates its shadow DOM asynchronously - poll briefly until it's there.
  // Products without a Skio plan never get a picker, so this simply gives up
  // and the page renders exactly as it would on the control template.
  function boot() {
    if (init()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (init() || tries > 60) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
